const networkingConfig = {
    development: {
        baseURL: 'http://localhost:5000'
    },
    staging: {
        baseURL: 'https://omyfu-ngin-staging.herokuapp.com'
    },
    production: {
        baseURL: 'https://omyfu-ngin.herokuapp.com'
    }
}

export default networkingConfig



// WEBPACK FOOTER //
// ./src/config/networking/config.js